/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const EmptySetIcon = ({
  className,
  style,
  color,
  onClick,
}: IconTypeProps) => {
  const fill = color || '#E94D7B';
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M14.8439 0.593667L14.4652 0.21814C14.2559 0.0106201 13.9167 0.0106201 13.7075 0.21814L11.4384 2.46832C10.3499 1.62927 8.98616 1.12492 7.50089 1.12492C3.95045 1.12492 1.07232 3.97906 1.07232 7.49992C1.07232 8.97281 1.58091 10.3252 2.42701 11.4046L0.157924 13.6551C-0.0513393 13.8626 -0.0513393 14.199 0.157924 14.4065L0.536607 14.7817C0.74587 14.9892 1.08504 14.9892 1.29431 14.7817L3.56339 12.5315C4.65156 13.3706 6.01562 13.8749 7.50089 13.8749C11.0513 13.8749 13.9295 11.0208 13.9295 7.49992C13.9295 6.02703 13.4209 4.67466 12.5748 3.59523L14.8439 1.34505C15.0531 1.13753 15.0531 0.800854 14.8439 0.593667ZM2.67946 7.49992C2.67946 4.86359 4.84241 2.71867 7.50089 2.71867C8.54018 2.71867 9.49777 3.05435 10.2859 3.61117L3.57913 10.2618C3.01763 9.48015 2.67946 8.53087 2.67946 7.49992ZM12.3223 7.49992C12.3223 10.1362 10.1594 12.2812 7.50089 12.2812C6.46127 12.2812 5.50402 11.9458 4.71551 11.3887L11.4223 4.73808C11.9842 5.51968 12.3223 6.46929 12.3223 7.49992Z"
        fill={fill}
      />
    </svg>
  );
};
